<template>
  <Transition name="slide-fadeUp" appear>
    <div v-if="visible" class="modal-center">
      <div v-if="currentStep!==0" class="modal-content">
        <div  class="left-content">
        <div class="modal-right">
          <div class="modal-right-header">
            <span class="step-text">{{$t('step')}}: {{ currentStepText }}</span>
            <span class="step-title">{{currentStepDescription}}</span>
          </div>

          <div class="modal-right-body">
            <div class="step-description" v-if="currentStepLongDescription !== ''">
              <img  class="hint-image" src="@/assets/images/lightbulbBlue.svg">
              <span class="hint-text"><span style="font-weight: bold">{{$t('hint')}}: </span>{{currentStepLongDescription}}</span>
            </div>

            <div class="step-inputs" v-if="currentStep === 1">
              <span>{{$t('range_of_skills')}}</span>
              <input
                  class="form-input"
                  :placeholder="this.$t('example_target_audience')"
                  v-model="generateData.skill"
                  v-textarea-autoresize />

              <span class="suggestion-text">{{$t('suggestions')}}:</span>
              <div class="tag-selects">
                <span class="tag-select" @click="selectSkillTag($t('leadership_training'))">{{$t('leadership_training')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('sales_enablement'))">{{$t('sales_enablement')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('new_hire_onboarding'))">{{$t('new_hire_onboarding')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('job_aids'))">{{$t('job_aids')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('internal_communications'))">{{$t('internal_communications')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('management_training'))">{{$t('management_training')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('deskless_workers_training'))">{{$t('deskless_workers_training')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('compliance_training'))">{{$t('compliance_training')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('training_reinforcement'))">{{$t('training_reinforcement')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('soft_skills_training'))">{{$t('soft_skills_training')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('safety_training'))">{{$t('safety_training')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('dei_training'))">{{$t('dei_training')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('distributor_training'))">{{$t('distributor_training')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('community_training'))">{{$t('community_training')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('spaced_training'))">{{$t('spaced_training')}} <img src="@/assets/images/plusBlack.svg"/></span>
                <span class="tag-select" @click="selectSkillTag($t('change_management'))">{{$t('change_management')}} <img src="@/assets/images/plusBlack.svg"/></span>
              </div>
            </div>

            <div class="step-inputs" v-if="currentStep === 2">
              <label class="form-label">{{$t('learner_roles')}}</label>
              <input class="form-input" v-model="generateData.audience.learnerRole" :placeholder="this.$t('example_target_audience')" v-textarea-autoresize />

              <label class="form-label mt-3">{{$t('learner_career_stage')}}</label>
              <div class="select-wrapper">
                <div
                    class="select-view"
                    @click="() => generateData.audience.learnerCareerStage = 'entry-level'"
                    :class="generateData.audience?.learnerCareerStage === 'entry-level' && 'selected'"
                >
                  <span>{{$t('entry_level')}}</span>
                </div>

                <div
                    class="select-view"
                    @click="() => generateData.audience.learnerCareerStage = 'mid-career'"
                    :class="generateData.audience?.learnerCareerStage === 'mid-career' && 'selected'"
                >
                  <span>{{$t('mid_career')}}</span>
                </div>

                <div
                    class="select-view"
                    @click="() => generateData.audience.learnerCareerStage = 'senior'"
                    :class="generateData.audience?.learnerCareerStage === 'senior' && 'selected'"
                >
                  <span>{{$t('senior')}}</span>
                </div>
              </div>

              <label class="form-label mt-3">Learner's level with this skill</label>
              <div class="select-wrapper">
                <div
                    class="select-view"
                    @click="() => generateData.audience.learnerLevel = 'beginner'"
                    :class="generateData.audience?.learnerLevel === 'beginner' && 'selected'"
                >
                  <span>{{$t('beginner')}}</span>
                </div>

                <div
                    class="select-view"
                    @click="() => generateData.audience.learnerLevel = 'intermediate'"
                    :class="generateData.audience?.learnerLevel === 'intermediate' && 'selected'"
                >
                  <span>{{$t('intermediate')}}</span>
                </div>

                <div
                    class="select-view"
                    @click="() => generateData.audience.learnerLevel = 'advanced'"
                    :class="generateData.audience?.learnerLevel === 'advanced' && 'selected'"
                >
                  <span>{{$t('advanced')}}</span>
                </div>
              </div>
            </div>

            <div class="step-inputs" v-if="currentStep === 3">
              <span>{{$t('learning_objectives')}}</span>
              <input class="form-input" v-model="generateData.learnerGoal" :placeholder="this.$t('example_facilitate_strategic_planning')" v-textarea-autoresize />
            </div>

            <div class="step-inputs" v-if="currentStep === 4">
              <span>{{$t('key_challenges')}}</span>
              <textarea class="form-input" v-model="generateData.learnerChallenges" :placeholder="this.$t('example_team_leads_struggle')"/>
            </div>

            <div class="step-inputs" v-if="currentStep === 5">
              <span>{{$t('program_context')}}</span>
              <textarea class="form-input" v-model="generateData.context" :placeholder="this.$t('example_company_scales_managers')"/>
            </div>

            <div class="step-inputs" v-if="currentStep === 6">
              <span>{{$t('generation_settings')}}</span>

              <div class="settings-wrapper">
                <span>{{$t('generate_videos_description')}}</span>
                <Switch v-model="generateData.generateVideos" />
              </div>

              <div class="settings-wrapper">
                <span>{{$t('storytelling_mode')}}</span>
                <Switch v-model="generateData.enableStorytelling" />
              </div>

              <div class="settings-wrapper">
                <span>{{$t('advanced_generation')}}</span>
                <Switch v-model="generateData.isAdvanced" />
              </div>

            </div>
          </div>
        </div>

        <div class="separator" />
        <div class="modal-left">
            <button class="dark-button-outline" @click="handlePrev">
              <span v-if="currentStep === 1">{{$t('cancel_button')}}</span>
              <span v-else>{{$t('go_back_button')}}</span>
            </button>

          <div class="stepper-wrapper no-text-select">
            <div class="step-wrapper" :class="currentStep === 1 ? 'current' : currentStep > 1 ? 'completed' : ''">
              <div class="step-circle">
                <span>1</span>
              </div>

            </div>

            <div class="step-wrapper" :class="currentStep === 2 ? 'current' : currentStep > 2 ? 'completed' : ''">
              <div class="step-circle">
                <span>2</span>
              </div>

            </div>

            <div class="step-wrapper" :class="currentStep === 3 ? 'current' : currentStep > 3 ? 'completed' : ''">
              <div class="step-circle">
                <span>3</span>
              </div>

            </div>

            <div class="step-wrapper" :class="currentStep === 4 ? 'current' : currentStep > 4 ? 'completed' : ''">
              <div class="step-circle">
                <span>4</span>
              </div>

            </div>

            <div class="step-wrapper" :class="currentStep === 5 ? 'current' : currentStep > 5 ? 'completed' : ''">
              <div class="step-circle last">
                <span>5</span>
              </div>
            </div>

            <div class="step-wrapper" :class="currentStep === 6 ? 'current' : currentStep > 6 ? 'completed' : ''">
              <div class="step-circle last">
                <span>6</span>
              </div>
            </div>
          </div>
          <button class="primary-button" :class="!nextEnabled && 'disabled'" @click="handleNext" :disabled="!nextEnabled || actionProcessing">
            <template v-if="!actionProcessing">
              <span v-if="currentStep < 6">{{$t('next')}}</span>
              <span v-else>{{$t('generate')}}</span>
            </template>

            <template v-else>
              <VueSpinnerIos color="#000"/>
            </template>
          </button>
        </div>
        </div>
        <div  class="right-banner" :class="`banner-step-${currentStep}`">
          <div class="cross-holder">
            <div @click="handleClose" class="close-btn">
              <img class="cross" src="../../assets/images/cross.svg" />
            </div>
          </div>
           <img class="nano-image" :src="currentStepImage">
          <div class="right-text-holder">
          <h3>{{$t('did_you_know_that')}}</h3>
          <span>{{currentStepFact}}</span>
          </div>
        </div>
      </div>
      <div v-else class="modal-notice-content">
        <div class="notice-holder">
          <div>
            <div class="cross-holder">
              <div @click="handleClose" class="close-btn">
                <img class="cross" src="../../assets/images/cross.svg" />
              </div>
            </div>
            <div style="padding: 10px 40px">
              <img class="notice-image" src="@/assets/images/nanoNotice.svg">
              <div class="notice-text-holder">
                <h3>{{$t('good_to_know')}}</h3>
                <div style="display: flex; flex-direction:column;gap:20px">
                <span style="font-size: 16px; line-height: 1.1">{{$t('nano_notice_text_1')}}</span>
                <span style="font-size: 16px; line-height: 1.1">{{$t('nano_notice_text_2')}}</span>
                <span style="font-size: 16px; line-height: 1.1">{{$t('nano_notice_text_3')}}</span>
                </div>
              </div>
              <div class="notice-bottom-actions">
                <div class="notice-check-holder">
                  <img width="24" v-if="!this.showNotice" src="@/assets/images/checkMultiple.svg" @click="toggleNotice">
                  <img width="24" v-if="this.showNotice" src="@/assets/images/checkSquareGreenFilled.svg" @click="toggleNotice">
                  <span>{{$t('dont_show_again')}}</span>
                </div>
                <button class="action-button"  @click="handleNext">
                  <span v-if="currentStep < 6">{{$t('lets_start')}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </Transition>
</template>

<script>
import Switch from "@/components/Switch.vue";
import FileDrop from "@/components/FileDrop.vue";
import programService from "../../service/programService";
import gameLabService from "../../service/gameLabService";
import {handleErrorResponse} from "@/utils/utils";
import stepImage1 from '@/assets/images/nanoCourseCreate1.svg';
import stepImage2 from '@/assets/images/nanoCourseCreate2.svg';
import stepImage3 from '@/assets/images/nanoCourseCreate3.svg';
import stepImage4 from '@/assets/images/nanoCourseCreate4.svg';
import stepImage5 from '@/assets/images/nanoCourseCreate5.svg';
import {VueSpinnerIos} from "vue3-spinners";


export default {
  components: {
    FileDrop,
    Switch,
    VueSpinnerIos
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {}
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    onAction: {
      type: Function,
      default: () => {}
    },
    editMode: {
      type: Boolean,
      default: true
    },
    actionProcessing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showNotice:false,
      currentStep: 0,
      steps: {
        0:{
          title:'Bilmekte Fayda Var',
          description:'description'
        },
        1: {
          title: 'Skill Development',
          description: this.$t('what_specific_skills_will'),
          longDescription: this.$t('practical_actions_techniques'),
          fact:this.$t('nano_fact_1'),
          image:stepImage1
        },
        2: {
          title: 'Target Audience',
          description: this.$t('identify_intended_audience'),
          longDescription: this.$t('who_is_program_designed_for'),
          fact:this.$t('nano_fact_2'),
          image:stepImage2

        },
        3: {
          title: this.$t('learning_objectives'),
          description: this.$t('what_competencies_learners_gain'),
          longDescription: this.$t('outline_expected_outcomes'),
          fact:this.$t('nano_fact_3'),
          image:stepImage3

        },
        4: {
          title: this.$t('key_challenges'),
          description: this.$t('identify_address_challenges'),
          longDescription: this.$t('workplace_challenges_participants_face'),
          fact:this.$t('nano_fact_4'),
          image:stepImage4
        },
        5: {
          title: this.$t('program_context'),
          description: this.$t('establish_broader_context'),
          longDescription: this.$t('organizational_factors_impact'),
          fact:this.$t('nano_fact_5'),
          image: stepImage5
        },
        6: {
          title: this.$t('generation_settings'),
          description: this.$t('generation_settings_description'),
          longDescription: '',
          fact:this.$t('nano_fact_5'),
          image: stepImage5
        }
      },
      generateData: {
        skill: "",
        audience: {
          learnerRole: "",
          learnerCareerStage: "",
          learnerLevel: ""
        },
        learnerGoal: "",
        learnerChallenges: "",
        context: "",
        generateVideos: true,
        enableStorytelling: true,
        isAdvanced: false
      },
    }
  },
  methods: {
    toggleNotice(){
      this.showNotice=!this.showNotice
    },
    handlePrev() {
      if (this.currentStep === 1) {
        this.generateData = {
          skill: "",
          audience: {
            learnerRole: "",
            learnerCareerStage: "",
            learnerLevel: ""
          },
          learnerGoal: "",
          learnerChallenges: "",
          context: ""
        };
        this.onHide();
      } else {
        this.currentStep -= 1;
      }
    },

    handleNext() {
      if (this.currentStep === 6) {
        this.onAction(this.generateData);
        this.onHide();
      } else {
        this.currentStep += 1;
      }
    },
    selectSkillTag(tag) {
      this.generateData.skill = tag;
    },
    handleClose() {
      this.generateData = {
        skill: "",
        audience: {
          learnerRole: "",
          learnerCareerStage: "",
          learnerLevel: ""
        },
        learnerGoal: "",
        learnerChallenges: "",
        context: ""
      };
      this.currentStep = 1;
      this.onHide();
    }
  },
  computed: {
    nextEnabled() {
      if (this.currentStep === 1) {
        return this.generateData.skill?.length > 0;
      } else if (this.currentStep === 2) {
        return this.generateData.audience?.learnerRole?.length > 0 && this.generateData.audience?.learnerCareerStage?.length > 0 && this.generateData.audience?.learnerLevel?.length > 0;
      } else if (this.currentStep === 3) {
        return this.generateData.learnerGoal?.length > 0;
      } else if (this.currentStep === 4) {
        return this.generateData.learnerChallenges?.length > 0;
      } else if (this.currentStep === 5) {
        return this.generateData.context?.length > 0;
      } else if (this.currentStep === 6) {
        return true;
      }
    },
    currentStepDescription() {
      return this.steps[this.currentStep]?.description;
    },
    currentStepText(){
      return this.steps[this.currentStep]?.title
    },
    currentStepLongDescription() {
      return this.steps[this.currentStep]?.longDescription;
    },
    currentStepFact(){
      return this.steps[this.currentStep]?.fact
    },
    currentStepImage(){
      return this.steps[this.currentStep]?.image
    }
  }
};
</script>

<style scoped>
.modal-content {
  position: relative;
  background-color: white;
  width: 70%;
  height: 100%;
  border-radius: 12px;
  padding: 0px !important;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 48px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: row;
}

.modal-notice-content {
  position: relative;
  background-color: #F9F6F2;
  width: 50%;
  height: 100%;
  border-radius: 12px;
  padding: 0px !important;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 80vh;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: row;
}

.modal-left {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 28px;
  width: 100%;
  gap:50px
}

.modal-right {
  flex: 3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.modal-content::-webkit-scrollbar {
  width: 15px;
}

.modal-content::-webkit-scrollbar-track {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #FFF;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(4, 12, 45, 0.2);
  border-radius: 10px;
  border: 5px transparent solid;
  background-clip: padding-box;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(4, 12, 45, 0.4);
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
}

.cross{
  padding: 8px;
}

.modal-right-header{
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  border: none;
  gap: 2px;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 24px;
}
.cross-holder{
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  border: none;
  gap: 2px;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 24px;
}
.step-title{
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 24px;
  font-style: normal;
  line-height: 36px;
}

h5 {
  font-family: euclid_medium, sans-serif;
  color: #010511;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 20px;
}

.stepper-wrapper {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.step-wrapper {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  cursor: default;
}

.step-circle {
  position: relative;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #F2F4F7;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s;
}

.step-wrapper.current .step-circle {
  background-color: #040C2D;
}

.step-wrapper.completed .step-circle {
  background-color: #3DA33E;
}



.step-wrapper.completed .step-circle:after {
  background-color: #3DA33E;
}

.step-circle.last:after {
  display: none;
  height: 0;
}

.step-circle span {
  font-family: euclid_semi_bold, sans-serif;
  color: #667085;
  font-size: 16px;
  font-style: normal;
  line-height: 14px;
}

.step-wrapper.current .step-circle span, .step-wrapper.completed .step-circle span {
  color: white;
}

.step-wrapper h5 {
  font-family: euclid_semi_bold, sans-serif;
  color: #667085;
  font-size: 14px;
  font-style: normal;
  line-height: 14px;
  margin: 0 !important;
}


.step-wrapper.current h5 {
  color: #040C2D;
}

.step-wrapper.completed h5 {
  color: #3DA33E;
}

.separator{
  width: 100%;
  background-color: #EAECF0;
  height: 1px;
}

.modal-right-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 24px;
  overflow-y: scroll;
  flex: 1;
  width: 100%;
}

.modal-right-footer {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
  border-top: 1px solid #EAECF0;
  width: 100%;
  padding: 13px;
}

.step-description {
  font-family: euclid_medium, sans-serif;
  color: #667085;
  font-size: 18px;
  font-style: normal;
  line-height: 22px;
  background-color: #EBEDFB;
  border-radius: 8px;
  padding: 12px;
  margin-right: 4px
}

.step-inputs {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-top: 15px;
}

.select-wrapper {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.settings-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #EAECF0;
}

.select-view {
  padding: 10px 15px;
  border: 1px solid #EAECF0;
  border-radius: 9px;
  transition: all 0.4s;
  cursor: pointer;
}

.select-view:hover {
  background-color: #EAECF0;
}

.select-view span {
  font-family: euclid_medium, sans-serif;
  color: #667085;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}

.select-view.selected {
  background-color: #EAECF0;
  border: 1px solid #040C2D;
}

.select-view.selected span {
  color: #040C2D;
}

textarea {
  min-height: 250px;
}

.tag-selects {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tag-select {
  padding: 10px 15px;
  border: 1px solid #EAECF0;
  border-radius: 3000px;
  transition: all 0.4s;
  cursor: pointer;
}

.tag-select:hover {
  background-color: #EAECF0;
}

.tag-select {
  font-family: euclid_medium, sans-serif;
  color: #667085;
  font-size: 10px;
  font-style: normal;
  line-height: 10px;
}

.left-content{
  display:flex;
  flex-direction: column;
  width: 100%;
}

.right-banner{
  display: flex;
  flex-direction: column;
  width: 40%;
  background-color: #F9F6F2;
}
.banner-step-1 {
  background-color: #F9F6F2;
}

.banner-step-2 {
  background-color: #EBEDFB ;
}

.banner-step-3 {
  background-color: #EFF8EF;
}
.banner-step-4 {
  background-color: #FFF4EE;
}
.banner-step-5 {
  background-color: #FAEEFF;
}
.right-text-holder{
  display: flex;
  flex-direction: column;
  align-self: center;
  margin-top: 5%;
  text-align: center;
  gap: 1rem;
}

.right-text-holder h3{
  font-size: 24px;
  color: #101828;
  font-weight: bold;
}

.right-text-holder span{
  font-size: 14px;
  color:#475467;
  padding: 5px;
}

.notice-text-holder{
  display: flex;
  flex-direction: column;
  align-self: center;
  text-align: start;
  gap: 1rem;
  margin-top: 30px;
}

.notice-text-holder h3{
  font-size: 24px;
  color: #101828;
  font-weight: bold;
}

.notice-text-holder span{
  font-size: 14px;
  color:#475467;
}

.nano-image{
  margin-top: 20%;
  padding: 15px 0 0px 50px;
}

.hint-image{
  width: 16px;
  height: 16px;
}

.hint-text{
  color: #101828;
  font-size: 12px;
}

.step-text{
  color:#667085;
  font-size: 16px;
}

.suggestion-text{
  margin-top: 15px;
  font-size: 12px;
  color:#667085
}

.notice-holder{
  width: 100%;
}

.notice-image{
  display: flex;
  align-self: center;
  justify-self: flex-start;
}

.notice-bottom-actions{
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.notice-check-holder{
  display: flex;
  gap: 3px;
}
</style>
